import { Button, Stack, Typography } from "@mui/material";
import ImageUploader from "src/components/ImageUploader";
import { useIsMobile } from "src/hooks/useIsMobile";
// import { usePhotoIdentificationMutation } from "src/api/services/patientApi";
import { useCallback, useState } from "react";
import { useTrack } from "src/hooks/useTrack";
import { useTranslation } from "react-i18next";
import IdConfirmation from "../components/IdConfirmation";
import { convertToBlob } from "src/utils/convertToBlob";
import { FileType } from "src/api/types";
import { useProduct } from "src/context/ProductProvider";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";
import { useUploadFileMutation } from "src/api/services/bucketApi";

interface Props {
  fileName: string;
  type: "id" | "selfie";
}
const IDVerification = ({ fileName, type }: Props) => {
  const isMobile = useIsMobile();
  const { submitAnswer } = useSubmitAnswers();
  // const firstName = usePatient((patient) => patient.profile.first_name ?? "");
  // const lastName = usePatient((patient) => patient.profile.last_name ?? "");
  const [uploadFile] = useUploadFileMutation();
  // const [idVerification] = usePhotoIdentificationMutation();
  const [file, setFile] = useState<FileType | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const track = useTrack();
  const page = "identity-verification";
  const { t } = useTranslation();
  const productSlug = useProduct((p) => p.slug);

  const next = useCallback(() => {
    submitAnswer(["Ignore"]);
    setFile(null);
  }, [submitAnswer]);

  // const handleIdVerification = useCallback(
  //   async (idPhoto: FileType["fileToUpload"]) => {
  //     await idVerification({
  //       type: "id-verification",
  //       params: {
  //         firstName,
  //         lastName,
  //         idPhoto,
  //       },
  //     });

  //     track("Vouched-ID-uploaded", { product: productSlug });
  //   },
  //   [firstName, idVerification, lastName, productSlug, track]
  // );

  const onConfirm = useCallback(async () => {
    if (!file) {
      setError("Please select the image you want to upload");
      return;
    }
    setLoading(true);

    const blob = await convertToBlob(file.fileToUpload);

    // if (type === "id") {
    //   await handleIdVerification(file.fileToUpload);
    // }

    track("ID-uploaded", { product: productSlug });

    return uploadFile({
      file: blob,
      name: fileName,
      type: blob.type,
      folder: "identification",
    })
      .then(next)
      .catch((err) => {
        setError((err as Error).message);
      })
      .finally(() => setLoading(false));
  }, [file, fileName, next, productSlug, track, uploadFile]);

  const handleImage = useCallback(
    (image: FileType | null) => {
      setFile(image);
      setError("");
    },
    [setFile],
  );

  const deleteFile = useCallback(() => {
    handleImage(null);
  }, [handleImage]);

  return (
    <Stack gap={2}>
      <Stack gap={2}>
        <Typography variant={isMobile ? "h5" : "h4"} fontWeight={700}>
          {t(`${page}.root.${file ? `title2_${type}` : `title_${type}`}`)}
        </Typography>
        <Typography variant={isMobile ? "subtitle2" : "subtitle1"}>
          {t(`${page}.root.subtitle_${type}`)}
        </Typography>
      </Stack>
      <Stack>
        <ImageUploader
          title={null}
          subtitle={null}
          name={fileName}
          file={file}
          folder="identification"
          setFilePath={handleImage}
          subImageTextTwo={`Click to upload or drag into here`}
          subImageTextMobile={`Click to upload or drag into here`}
        />

        <Button
          variant="text"
          onClick={next}
          size="small"
          sx={{ alignSelf: "center" }}
        >
          <Typography variant="subtitle2">{t(`button.continue`)}</Typography>
        </Button>
      </Stack>
      {error ? (
        <Typography sx={{ color: "red" }} textAlign="center">
          {error}
        </Typography>
      ) : null}
      {file && (
        <IdConfirmation
          deleteFile={deleteFile}
          onConfirm={onConfirm}
          loading={loading}
          type={type}
        />
      )}
      {type === "id" ? (
        <Typography variant={isMobile ? "subtitle2" : "subtitle1"}>
          {t(`${page}.root.subtext`)}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default IDVerification;
